// import external dependencies
// import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import archive from './routes/archive';
import templateHome from './routes/templateHome';
import templateAbout from './routes/templateAbout';
import templateRecent from './routes/templateRecent';
import templatePromo from './routes/templatePromo';
import singleProduct from './routes/singleProduct';
import woocommerceCart from './routes/woocommerceCart';
import woocommerceCheckout from './routes/woocommerceCheckout';
import search from './routes/search';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // Shop page
  archive,
  // All pages
  common,
  //Home Page
  templateHome,
  //Template About
  templateAbout,
  //Template Recent
  templateRecent,
  //Template Recent
  templatePromo,
  //Single Product page
  singleProduct,
  //Cart page
  woocommerceCart,
  //Cart page
  woocommerceCheckout,
  //Search results page
  search,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents();
}, false);




// WEBPACK FOOTER //
// ./scripts/main.js